export { Slider as default } from './Slider';
